<script>
  import { format } from 'svelte-i18n';

  import { ShowMore } from '@client/components/show-more';

  import { COMPLIANCE_ACTIONS, COMPLIANCE_ACTIONS_OPTIONS_FIELDS } from '@client/enums';

  export let actions = [];
</script>

<div class="card p-4 mt-4">
  <b class="mb-2">{$format('label.COMPLIANCE_ACTIONS')}</b>
  {#each actions as action}
    {@const description = $format(COMPLIANCE_ACTIONS[action.name].description)}
    <div class="mb-2" style="border-left: 3px solid {COMPLIANCE_ACTIONS[action.name].bg};">
      <div class="px-2">
        <b>{$format(COMPLIANCE_ACTIONS[action.name].label)}</b>
        {#if Object.values(action.options || {}).length}
          {@const toggle = COMPLIANCE_ACTIONS[action.name].toggle}

          {#if toggle}
            <p>{description}</p>
            <ShowMore collapsedText={$format(toggle.collapsedText)} expandedText={$format(toggle.expandedText)}>
              <div class="m-2">
                {#each Object.entries(action.options) as [key, value]}
                  {@const label = $format(COMPLIANCE_ACTIONS_OPTIONS_FIELDS[key])}
                  <p>
                    <b>{label}</b>: <span>{value}</span>
                  </p>
                {/each}
              </div>
            </ShowMore>
          {/if}
        {:else}
          <p>{description}</p>
        {/if}
      </div>
    </div>
  {/each}
</div>

<style lang="scss" src="./compliance-actions.scss"></style>
